import { render, staticRenderFns } from "./AllCategories.vue?vue&type=template&id=61e46b3a&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"
import style0 from "./AllCategories.vue?vue&type=style&index=0&id=61e46b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e46b3a",
  null
  
)

export default component.exports